import Vue from 'vue'
import Component from 'vue-class-component'

interface IFormMix {
    messageAlert: (text: string) => Promise<void>;
  }
  

@Component
export class FormMix extends Vue implements IFormMix {
    token = localStorage.getItem('token');
    formReady: boolean = false
    tableLoad: boolean = false
    
    constructor() {
        super();
    }

    async messageAlert(text: string): Promise<void> {
        this.$message.warning(text)
    }
    // async created(): Promise<void> {
    //     this.$message.warning('подождите немного')
    // }
}
